import { render } from "./ZuwegungMast.vue?vue&type=template&id=65f64e65&scoped=true&ts=true"
import script from "./ZuwegungMast.vue?vue&type=script&lang=ts"
export * from "./ZuwegungMast.vue?vue&type=script&lang=ts"

import "./ZuwegungMast.vue?vue&type=style&index=0&id=65f64e65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f64e65"]])

export default __exports__